import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import { logout } from '../redux/modules/login/actions';
import {revokeToken} from '../redux/modules/logout/actions';
import Cookies from 'js-cookie';
import { removeAuthDetails } from './AuthDetailsUtil';

const LogOutUtil = () => {
  let navigate = useNavigate();
  const dispatch = useDispatch();

  const clearAllCookies = () => {
    const allCookies = Cookies.get(); // Get all cookies
    Object.keys(allCookies).forEach((cookie) => {
      Cookies.remove(cookie, { path: '' }); // Clear each cookie
    });
  }

  const logOutUser = () => {
    //perform logout
    dispatch(revokeToken());
    dispatch(logout());
    removeAuthDetails();
    clearAllCookies();
    navigate('/');
  };
  return { logOutUser };
};
export default LogOutUtil;
